import { LoadingButton } from "@mui/lab";
import { Box, FormGroup, TextField } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import $api, { extractAuthToken, setAuthToken } from "../http";
import { enqueueSnackbar } from "notistack";

const Login = (props) => {
    const { url, loginType = 'login', onSuccess } = props;
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isSubmit, setIsSubmit] = useState(false);

    const { t } = useTranslation();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmit(true);
        try {
            const res = await $api.post('/kb/auth', {
                url: url,
                email: email,
                password: password
            });
            const token = extractAuthToken(res?.data);

            if (token) {
                setAuthToken(token);
            }

            if (typeof onSuccess === 'function') {
                onSuccess(res);
            }
        } catch (err) {
            enqueueSnackbar(err?.response?.data?.message || err?.response?.message || t('Login failed'), {
                variant: 'error'
            });
        } finally {
            setIsSubmit(false);
        }
    };

    return (
        <Box onSubmit={handleSubmit} component="form" sx={{ width: '80%', minWidth: 300 }}>
            {(loginType === 'login') && (
                <FormGroup>
                    <TextField
                        name="email"
                        label={t('Email')}
                        value={email}
                        type="email"
                        required
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </FormGroup>
            )}
            <FormGroup sx={{ mt: 2 }}>
                <TextField
                    name="password"
                    required
                    label={t('Password')}
                    value={password}
                    type="password"
                    onChange={(e) => setPassword(e.target.value)}
                />
            </FormGroup>
            <FormGroup sx={{ mt: 2 }}>
                <LoadingButton loading={isSubmit} type="submit" variant="contained" color="primary" disableElevation size="large">
                    {t('Login')}
                </LoadingButton>
            </FormGroup>
        </Box>
    );
};

export default Login;
